import React from 'react'
import PropTypes from 'prop-types'
import { Link, graphql } from 'gatsby'

import Layout from '../components/layout'

const Index = props => {
  const {
    data: {
      allMarkdownRemark: { edges: pageContainers },
    },
  } = props
  const pages = pageContainers.map(({ node }) => node)

  const filterPagesByType = (type, pages) =>
    pages.filter(p => p.frontmatter.type === type)

  const oifs = filterPagesByType('Object in Focus', pages)
  const ffs = filterPagesByType('Five Facts', pages)

  return (
    <Layout>
      <h1>Teaching the Arts</h1>

      <h2 id="object-in-focus">Object in Focus</h2>
      <EntryListing pages={oifs} />

      <h2 id="five-facts">Five Facts</h2>
      <EntryListing pages={ffs} />
    </Layout>
  )
}

const EntryListing = ({ pages }) => {
  return (
    <ul className="row">
      {pages.map(page => {
        const {
          frontmatter: { name: title },
          fields: { slug, referencedArtworkIds: artworkIds },
        } = page

        return (
          <li className="row thirds" key={slug}>
            <div className="col col-6">
              {artworkIds.length > 0 ? (
                <Link to={slug}>
                  <img
                    src={`https://1.api.artsmia.org/400/${artworkIds[0]}.jpg`}
                  />
                </Link>
              ) : null}
            </div>
            <div className="col col-6">
              <Link to={slug}>{title}</Link>
              <p>{page.excerpt}</p>
            </div>
          </li>
        )
      })}
    </ul>
  )
}

export const query = graphql`
  query {
    allMarkdownRemark {
      totalCount
      edges {
        node {
          id
          fields {
            slug
            referencedArtworkIds
          }
          excerpt
          fileAbsolutePath
          frontmatter {
            name
            type
          }
          headings {
            value
            depth
          }
          timeToRead
        }
      }
    }
  }
`

export default Index

Index.propTypes = {
  data: PropTypes.object,
}
EntryListing.propTypes = {
  pages: PropTypes.array,
}
